const dictionaries = {
  en: () => import("./en.json").then((module) => module.default),
  indo: () => import("./indo.json").then((module) => module.default),
};

export const getDictionary = (locale) => {
  const dictionary = dictionaries[locale]();
  return dictionary;
};
